import React from 'react';
import { isEmpty } from 'lodash';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Logger from '../../../../utils/Logger';
import Row from '../../../../components/tag/Row';
import Span from '../../../../components/tag/Span';
import Urls from '../../../../definitions/Urls';
import { getDepartmentDisplay } from '../../../../utils/TimelineUtils';
import BiobankLaboratoryInfo from './BiobankLaboratoryInfo';
var moment = require('moment');

let { id: module_id } = module;
const logger = new Logger(module_id);

const defaultMaxHeight = '90px';

class LaboratoryNotificationDescription extends React.Component {
  render() {
    let {
      organisationUnit,
      collectionTimeWindowEnd,
      collectionTimeWindowStart,
      requestedCollectionDateDate,
      requestedCollectionDateTime,
      tests,
      fasting,
      timeOfRequest,
      biopankki,
      isNotification,

      /* these are optionally passed on notification */
      setRef,
      isOpen,
      style,
    } = this.props;

    if (
      moment(requestedCollectionDateDate, 'DD.MM.YYYY').diff(
        moment(timeOfRequest, 'DD.MM.YYYY'),
        'days'
      ) < 8
    ) {
      collectionTimeWindowStart = timeOfRequest;
    }

    let hasRequestedCollectionDateTime =
      requestedCollectionDateTime !== '00:00';
    return (
      <>
        <Row>
          <Span>
            <span className="notification-info">
              <FormattedMessage
                id={'fimlab.description'}
                values={{
                  organisationUnit: getDepartmentDisplay(organisationUnit),
                  p: (chunks) => <p>{chunks}</p>,
                  br: <br />,
                }}
              />
            </span>
            <hr className="notification-divider" />
            <div className="notification-info">
              <FormattedMessage
                id={'fimlab.description.info'}
                values={{
                  br: <br />,
                }}
              />
            </div>
            <ul className="dash">
              <li>
                <FormattedMessage
                  id={'fimlab.description.date.only'}
                  values={{
                    organisationUnit: getDepartmentDisplay(organisationUnit),
                    collectionTimeWindowEnd,
                    collectionTimeWindowStart,
                    requestedCollectionDateDate: requestedCollectionDateDate,
                    requestedCollectionDateTime: requestedCollectionDateTime,
                    strong: (chunks) => <strong>{chunks}</strong>,
                  }}
                />
              </li>
            </ul>
            <div
              ref={setRef}
              style={style}
              className={classnames('notification-expand', {
                expanded: isOpen,
              })}
            >
              <Row>
                <ul className="dash">
                  <li>
                    <FormattedMessage
                      id={
                        fasting && fasting > 0
                          ? 'fimlab.description.fasting'
                          : 'fimlab.description.no.fasting'
                      }
                      values={{
                        fasting: fasting,
                        strong: (chunks) => <strong>{chunks}</strong>,
                        br: <br />,
                      }}
                    />
                  </li>
                  <li>
                    <FormattedMessage
                      id={'fimlab.description.equipments'}
                      values={{
                        br: <br />,
                        strong: (chunks) => <strong>{chunks}</strong>,
                      }}
                    />
                  </li>
                  <li>
                    <FormattedMessage
                      id={'fimlab.description.appointment'}
                      values={{
                        strong: (chunks) => <strong>{chunks}</strong>,
                        u: (chunks) => <u>{chunks}</u>,
                        a: (chunks) => (
                          <a
                            href={Urls.fimlabAppointment}
                            target="_blank"
                            onClick="arguments[0].stopPropagation();"
                          >
                            {chunks}
                          </a>
                        ),
                        br: <br />,
                      }}
                    />
                  </li>
                </ul>
              </Row>
              <hr className="notification-divider" />
              <Row>
                <div className="notification-info">
                  <FormattedMessage id="fimlab.tests" />
                </div>
              </Row>
              <Row>
                <div className="notification-info">
                  <FormattedMessage id="fimlab.tests.info" />
                </div>
              </Row>
              <Row>
                <Span>
                  <ul className="splash">
                    {!isEmpty(tests) &&
                      tests.map((test) => {
                        return test.labTestName == null ? (
                          <li
                            className="infoList"
                            key={`${test.labTestId}-${test.labTestAbbreviation}`}
                          >
                            {test.labTestId} - {test.labTestAbbreviation}
                          </li>
                        ) : (
                          <li
                            className="infoList"
                            key={`${test.labTestId}-${test.labTestAbbreviation}`}
                          >
                            {test.labTestId} - {test.labTestAbbreviation},{' '}
                            {test.labTestName}
                          </li>
                        );
                      })}
                  </ul>
                </Span>
              </Row>
              <Row>
                <Span>
                  {biopankki && (
                    <BiobankLaboratoryInfo
                      theme={isNotification ? 'blue' : 'white'}
                    />
                  )}
                </Span>
              </Row>
            </div>
          </Span>
        </Row>
      </>
    );
  }
}

export default LaboratoryNotificationDescription;
